const SCRIPT_LOADED = new Set();
export function getFormsDomain(env) {
  return env === 'qa' ? 'hsformsqa.net' : 'hsforms.net';
}
export function injectScript(src, onLoad) {
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) {
    if (SCRIPT_LOADED.has(src)) {
      onLoad === null || onLoad === void 0 || onLoad();
    } else {
      existing.addEventListener('load', () => onLoad === null || onLoad === void 0 ? void 0 : onLoad(), {
        once: true
      });
    }
    return;
  }
  const script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.addEventListener('load', () => {
    SCRIPT_LOADED.add(src);
    onLoad === null || onLoad === void 0 || onLoad();
  }, {
    once: true
  });
  document.body.appendChild(script);
}